import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { apiSlice } from "./apiSlice";
import restaurantSlice from "./restaurantsSlice";
import restaurantSearchSlice from "./restaurantSearchSlice";
import cartSlice from "./cartSlice";
import cartSearchSlice from "./cartSearchSlice";
import cartPersonSlice from "./cartPersonSlice";
import orderRefundSlice from "./orderRefundSlice";
import commissionSlice from "./commissionSlice";
import payoutSlice from "./payoutSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["restaurant", "cart",],
};

const rootReducer = combineReducers({
  restaurant: restaurantSlice,
  restaurantSearch: restaurantSearchSlice,
  cart: cartSlice,
  cartSearch: cartSearchSlice,
  cartPersons: cartPersonSlice,
  refundOrder: orderRefundSlice,
  Commission: commissionSlice,
  payouts: payoutSlice,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
        ],
      },
    }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
